module.exports = __webpack_public_path__ + "img/imgvallea.b4d3730d.png";